import { render, staticRenderFns } from "./ContactTeam.vue?vue&type=template&id=5a56ae28&"
import script from "./ContactTeam.vue?vue&type=script&lang=js&"
export * from "./ContactTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports